import Axios from 'axios';
import { format } from 'date-fns';

const BASE_URL = import.meta.env.VITE_API_URL;
const JSON_HEADER = { 'Content-Type': 'application/json' };

export default {
  async isValidEmail(email) {
    const response = await Axios.post(
      BASE_URL,
      {
        functionName: 'isEmailValid',
        email: email.toLowerCase(),
      },
      {
        headers: JSON_HEADER,
      },
    );
    return response.data;
  },
  async createUserAndIdam(email, organization, user) {
    const response = await Axios.post(
      BASE_URL,
      {
        functionName: 'createUserAndIdam',
        email: email.toLowerCase(),
        first_name: user.first_name,
        last_name: user.last_name,
        organization: organization,
        social_security_number: user.social_security_number,
        employment_date: user.employment_date,
        employment_field: user.employment_field,
        employment_type: user.employment_type,
        job_title: user.job_title,
        country: user.country,
        street_address: user.street_address,
        postal_code: user.postal_code,
        city: user.city,
      },
      {
        headers: JSON_HEADER,
      },
    );
    return response.data;
  },
  async editUser(email, user) {
    const response = await Axios.post(
      BASE_URL,
      {
        functionName: 'editUser',
        email: email.toLowerCase(),
        first_name: user.first_name,
        last_name: user.last_name,
        social_security_number: user.social_security_number,
        employment_date: user.employment_date,
        employment_field: user.employment_field,
        employment_type: user.employment_type,
        job_title: user.job_title,
        country: user.country,
        street_address: user.street_address,
        postal_code: user.postal_code,
        city: user.city,
      },
      {
        headers: JSON_HEADER,
      },
    );
    return response.data;
  },
  async createIdamUser(email, idamUser) {
    const response = await Axios.post(
      BASE_URL,
      {
        functionName: 'createIdamUser',
        email: email.toLowerCase(),
        first_name: idamUser.firstName,
        last_name: idamUser.lastName,
        organization: idamUser.organization,
      },
      {
        headers: JSON_HEADER,
      },
    );
    return response.data;
  },
  async createAdditionalInformation(email, additionalInformation) {
    const response = await Axios.post(
      BASE_URL,
      {
        functionName: 'addUserAdditionalInformation',
        email: email.toLowerCase(),
        employment_situation: additionalInformation.employmentSituation,
        other_employment_situation: additionalInformation.other,
        former_company_cvr: additionalInformation.formerCompanyCvr,
        former_employment_country: additionalInformation.otherCompanyCountry,
      },
      {
        headers: JSON_HEADER,
      },
    );
    return response.data;
  },
  async createApplication(email, company, application, workplace, residence) {
    let departureDate = new Date(application.departure_date);
    let returnDate = new Date(application.return_date);

    const response = await Axios.post(
      BASE_URL,
      {
        functionName: 'createApplication',
        email: email.toLowerCase(),
        companyId: company.id,
        destinationId: application.destination.id,
        departure_date: format(departureDate, 'dd-MM-yyyy'),
        return_date: format(returnDate, 'dd-MM-yyyy'),
        workplace_name: workplace.name,
        workplace_address: workplace.address,
        workplace_city: workplace.city,
        residence_name: residence.name,
        residence_address: residence.address,
        residence_city: residence.city,
        token: application.token,
      },
      {
        headers: JSON_HEADER,
      },
    );
    return response.data;
  },
  async previewEmailsCsv(formData) {
    formData.append('functionName', 'previewEmailsCsv');
    const response = await Axios.post(BASE_URL, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },
  async addBulkEmails(company_id, emails) {
    const response = await Axios.post(
      BASE_URL,
      {
        functionName: 'addBulkEmails',
        company_id: company_id,
        emails: emails,
      },
      {
        headers: JSON_HEADER,
      },
    );
    return response.data;
  },
  async deleteBulkEmails(company_id, emails) {
    const response = await Axios.post(
      BASE_URL,
      {
        functionName: 'deleteBulkEmails',
        company_id: company_id,
        emails: emails,
      },
      {
        headers: JSON_HEADER,
      },
    );
    return response.data;
  },
  async removeAppUser(email, companyId) {
    const response = await Axios.post(
      BASE_URL,
      {
        functionName: 'removeAppUser',
        email: email.toLowerCase(),
        company_id: companyId,
      },
      {
        headers: JSON_HEADER,
      },
    );
    return response.data;
  },
  async addAppUser(email, companyId, userRole) {
    const response = await Axios.post(
      BASE_URL,
      {
        functionName: 'addAppUser',
        email: email.toLowerCase(),
        company_id: companyId,
        user_role: userRole,
      },
      {
        headers: JSON_HEADER,
      },
    );
    return response.data;
  },
  async getAppUsers(companyId) {
    const response = await Axios.post(
      BASE_URL,
      {
        functionName: 'getAppUsers',
        company_id: companyId,
      },
      {
        headers: JSON_HEADER,
      },
    );
    return response.data;
  },
  async getUserInformation(email) {
    const response = await Axios.post(
      BASE_URL,
      {
        functionName: 'getUserInformation',
        email: email.toLowerCase(),
      },
      {
        headers: JSON_HEADER,
      },
    );
    return response.data;
  },
  async getUnfinishedApplication(email) {
    const response = await Axios.post(
      BASE_URL,
      {
        functionName: 'getUnfinishedApplication',
        email: email.toLowerCase(),
      },
      {
        headers: JSON_HEADER,
      },
    );
    return response.data;
  },
  async deleteUnfinishedApplication(email, application_id) {
    const response = await Axios.post(
      BASE_URL,
      {
        functionName: 'deleteUnfinishedApplication',
        email: email.toLowerCase(),
        application_id: application_id,
      },
      {
        headers: JSON_HEADER,
      },
    );
    return response.data;
  },
  async getCountries() {
    const response = await Axios.post(
      BASE_URL,
      {
        functionName: 'getCountries',
      },
      {
        headers: JSON_HEADER,
      },
    );
    return response.data;
  },
  async getUserApplications(email) {
    const response = await Axios.post(
      BASE_URL,
      {
        functionName: 'getUserApplications',
        email: email.toLowerCase(),
      },
      {
        headers: JSON_HEADER,
      },
    );
    return response.data;
  },
  async getCompanyApplications(companyId) {
    const response = await Axios.post(
      BASE_URL,
      {
        functionName: 'getCompanyApplications',
        company_id: companyId,
      },
      {
        headers: JSON_HEADER,
      },
    );
    return response.data;
  },
  async getCompanyLimits(companyId) {
    const response = await Axios.post(
      BASE_URL,
      {
        functionName: 'getCompanyLimits',
        company_id: companyId,
      },
      {
        headers: JSON_HEADER,
      },
    );
    return response.data;
  },
  async getAllCompanies() {
    const response = await Axios.post(
      BASE_URL,
      {
        functionName: 'getAllCompanies',
      },
      {
        headers: JSON_HEADER,
      },
    );
    return response.data;
  },
  async getCompanyInfo(id) {
    const response = await Axios.post(
      BASE_URL,
      {
        functionName: 'getSingleCompany',
        id: id,
      },
      {
        headers: JSON_HEADER,
      },
    );
    return response.data;
  },
  async addCompany(name, cvr, max_allowed_emails, max_allowed_applications_per_year) {
    const response = await Axios.post(
      BASE_URL,
      {
        functionName: 'addCompany',
        name: name,
        cvr: cvr,
        max_allowed_emails: max_allowed_emails,
        max_allowed_applications_per_year: max_allowed_applications_per_year,
      },
      {
        headers: JSON_HEADER,
      },
    );
    return response.data;
  },
  async editCompany(name, cvr, max_allowed_emails, max_allowed_applications_per_year) {
    const response = await Axios.post(
      BASE_URL,
      {
        functionName: 'editCompany',
        name: name,
        cvr: cvr,
        max_allowed_emails: max_allowed_emails,
        max_allowed_applications_per_year: max_allowed_applications_per_year,
      },
      {
        headers: JSON_HEADER,
      },
    );
    return response.data;
  },
};
